import React, { useEffect, useState, useRef } from 'react';
import { Card, Form, Table, Badge as BsBadge, Button as BootstrapButton, Tooltip, OverlayTrigger, Modal, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { 
    YEUCAU_THAYDOI_API, 
    THAYDOI_DETAI_API, 
    THAYDOI_CBHD_API, 
    GIAHAN_DAOTAO_API,
    CHITIET_THAYDOI_CBHD_API,
    DUYET_THAYDOI_DETAI_API,
    DUYET_THAYDOI_CBHD_API,
    DUYET_GIAHAN_DAOTAO_API,
    DANHGIA_DETAI_API,
    DANHGIA_CBHD_API,
    DANHGIA_GIAHAN_API,
    BaseGatewayImage
} from '@app/utils/apiUrl';
import { Get, Put } from '@app/utils/httpProvider';
import { objectShowNumber, trangThaiYeuCauValue, objectLoaiYeuCau, loaiYeuCauValue, loaiCanBoHuongDanValue } from '@app/utils/define';
import { toast } from 'react-toastify';
import DanhGiaDeTaiForm from './DanhGiaDeTaiForm';
import DanhGiaCBHDForm from './DanhGiaCBHDForm';
import DanhGiaGiaHanForm from './DanhGiaGiaHanForm';

const FieldDisplayFile = ({ label, value }) => {
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    let files = [];
    if (value) {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) {
                files = parsed;
            } else {
                files = [{ filePath: value, name: value.split('/').pop() }];
            }
        } catch (e) {
            files = [{ filePath: value, name: value.split('/').pop() }];
        }
    }

    return (
        <Form.Group className="mb-3">
            {label && <Form.Label className="font-weight-bold">{label}</Form.Label>}
            <div className="d-flex flex-wrap">
                {files.length > 0 ? (
                    files.map((file, idx) => {
                        const path = file.filePath || file;
                        let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                        name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                        return (
                            <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-1`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={name}>
                                <i className="fas fa-paperclip mr-1"></i> {name}
                            </a>
                        );
                    })
                ) : (
                    <div className={label ? "d-flex align-items-center" : ""} style={label ? { height: '38px' } : {}}>
                        <span className="text-muted small">Không có file đính kèm</span>
                    </div>
                )}
            </div>
        </Form.Group>
    );
};

const getEnumValue = (value, valueMap) => {
    if (value === null || value === undefined || value === '') return value;
    if (typeof value === 'number') return value;
    if (typeof value === 'string' && valueMap) {
        if (valueMap[value] !== undefined) return valueMap[value];
        const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
        if (valueMap[camelCase] !== undefined) return valueMap[camelCase];
        const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
        if (matchKey) return valueMap[matchKey];
        if (!isNaN(value)) return parseInt(value);
    }
    return value;
};

const DuyetThayDoi = ({ search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, loaiYeuCauFilter }) => {
    const queryClient = useQueryClient();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [modalMode, setModalMode] = useState(''); // 'view' or trangThaiYeuCauValue properties
    const [action, setAction] = useState(trangThaiYeuCauValue.hoanThanh);
    const [ghiChu, setGhiChu] = useState('');
    const [ngayThongQua, setNgayThongQua] = useState('');
    const [selectedRow, setSelectedRow] = useState(null);
    const tableRef = useRef(null);

    const { isLoading, data, refetch } = useQuery(
        ['duyetThayDoi', search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, loaiYeuCauFilter, page, pageSize],
        async () => {
            const model = {
                Keyword: search || '',
                MaNCS: searchMaNCS || '',
                PageIndex: page,
                PageSize: pageSize
            };
            if (dotTuyenSinhId) model.DotTuyenSinhId = dotTuyenSinhId;
            if (thoiHanDaoTao) model.ThoiHanDaoTao = thoiHanDaoTao;
            if (trangThaiFilter) model.TrangThai = trangThaiFilter;
            if (loaiYeuCauFilter) model.LoaiYeuCau = loaiYeuCauFilter;
            
            const res = await Get(YEUCAU_THAYDOI_API.GET_PAGING, null, model);
            return res;
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page, search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, loaiYeuCauFilter]);

    const changePage = (number) => {
        setPage(number);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        setPage(1);
    };

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [items]);

    const handleAction = async (item, mode) => {
        let detailInfo = null;
        let chiTietThayDoiCBHDs = [];
        
        try {
            if (item.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                detailInfo = await Get(`${THAYDOI_DETAI_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
            } else if (item.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                detailInfo = await Get(`${THAYDOI_CBHD_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
                if (detailInfo && detailInfo.id) {
                    const ctRes = await Get(`${CHITIET_THAYDOI_CBHD_API.GET_BY_THAYDOI_ID}/${detailInfo.id}`);
                    if (ctRes) {
                        const rawData = ctRes.data || ctRes;
                        let chiTiets = rawData.$values || rawData;
                        if (!Array.isArray(chiTiets)) chiTiets = [];
                        const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
                        chiTietThayDoiCBHDs = chiTiets.map(ct => ({
                            ...ct,
                            loaiCanBoHuongDan: getEnumValue(ct.loaiCanBoHuongDan, customLoaiCanBoMap)
                        }));
                    }
                }
            } else if (item.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                detailInfo = await Get(`${GIAHAN_DAOTAO_API.GET_BY_YEUCAU_ID}/${item.id || item.Id}`);
            }
        } catch (e) {
            console.error("Lỗi lấy chi tiết", e);
        }

        const fullItem = {
            ...item,
            detailInfo,
            chiTietThayDoiCBHDs
        };

        setSelectedItem(fullItem);
        setModalMode(mode);
        if (mode !== 'view') {
            setAction(mode); 
        }
        setGhiChu(detailInfo?.ghiChuChinhSua || detailInfo?.GhiChuChinhSua || '');
        setNgayThongQua(detailInfo?.ngayThongQua ? moment(detailInfo.ngayThongQua).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'));
        setShowModal(true);
    };

    const submitDuyet = async () => {
        if (!selectedItem || !selectedItem.detailInfo) return;
        
        if (action === trangThaiYeuCauValue.hoanThanh) {
            let hasEvaluation = false;
            try {
                let evalRes = null;
                const detailId = selectedItem.detailInfo.id;
                if (selectedItem.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai) {
                    evalRes = await Get(`${DANHGIA_DETAI_API.GET_BY_THAYDOI_ID}/${detailId}`);
                } else if (selectedItem.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                    evalRes = await Get(`${DANHGIA_CBHD_API.GET_BY_THAYDOI_ID}/${detailId}`);
                } else if (selectedItem.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                    evalRes = await Get(`${DANHGIA_GIAHAN_API.GET_BY_THAYDOI_ID}/${detailId}`);
                }
                
                const evalData = evalRes?.data || evalRes;
                if (evalData && evalData.id) {
                    hasEvaluation = true;
                }
            } catch (error) {
                console.error("Lỗi kiểm tra đánh giá:", error);
            }

            if (!hasEvaluation) {
                toast.warning('Chưa có dữ liệu đánh giá. Vui lòng cập nhật đánh giá trước khi duyệt!');
                return;
            }
        }

        const body = {
            TrangThaiYeuCau: action,
            GhiChuChinhSua: ghiChu,
            NgayThongQua: action === trangThaiYeuCauValue.hoanThanh && ngayThongQua ? ngayThongQua : null
        };

        try {
            let apiUrl = DUYET_THAYDOI_DETAI_API.DUYET_HO_SO;
            if (selectedItem.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD) {
                apiUrl = DUYET_THAYDOI_CBHD_API.DUYET_HO_SO;
            } else if (selectedItem.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao) {
                apiUrl = DUYET_GIAHAN_DAOTAO_API.DUYET_HO_SO;
            }

            const res = await Put(apiUrl, selectedItem.detailInfo.id, body);
            if (res && (res.id || res.success || res.status === 200)) {
                toast.success('Thao tác thành công!');
                setShowModal(false);
                refetch();
                queryClient.invalidateQueries(['duyetThayDoi']);
                queryClient.invalidateQueries(['yeuCauThayDoiData']);
            } else {
                toast.error('Có lỗi xảy ra!');
            }
        } catch (error) {
            toast.error('Có lỗi xảy ra!');
        }
    };

    const renderTooltip = (props, text) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    const getTrangThaiLabel = (val) => {
        switch (val) {
            case 0:
            case trangThaiYeuCauValue.choGui: return <BsBadge variant="secondary">Chờ gửi</BsBadge>;
            case 1:
            case trangThaiYeuCauValue.dangXuLy: return <BsBadge variant="primary">Đang xử lý</BsBadge>;
            case 2:
            case trangThaiYeuCauValue.boSung: return <BsBadge variant="warning">Cần chỉnh sửa</BsBadge>;
            case 3:
            case trangThaiYeuCauValue.hoanThanh: return <BsBadge variant="success">Hoàn thành</BsBadge>;
            case 4:
            case trangThaiYeuCauValue.tuChoi: return <BsBadge variant="danger">Từ chối</BsBadge>;
            default: return <BsBadge variant="secondary">Không xác định</BsBadge>;
        }
    };

    const getLoaiYeuCauText = (val) => {
        const item = objectLoaiYeuCau.find(x => x.value === val || x.value === parseInt(val));
        return item ? item.label : 'Không xác định';
    };

    const renderChiTietDeTai = () => (
        <>
            <Row>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Tên đề tài dự kiến</Form.Label>
                        <Form.Control type="text" value={selectedItem?.detailInfo?.tenDeTaiDuKien || ''} disabled={true} className="bg-white shadow-none" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Lý do thay đổi</Form.Label>
                        <Form.Control as="textarea" rows={3} value={selectedItem?.detailInfo?.lyDoThayDoi || ''} disabled={true} className="bg-white shadow-none" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={6} className="mb-3">
                    <FieldDisplayFile label="File ý kiến của CBHD" value={selectedItem?.detailInfo?.fileYKienCBHD} />
                </Col>
                <Col md={6} className="mb-3">
                    <FieldDisplayFile label="File minh chứng đề tài" value={selectedItem?.detailInfo?.fileMinhChungDeTai} />
                </Col>
            </Row>
            {selectedItem?.detailInfo?.ngayThongQua && (
                <Row>
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label className="font-weight-bold">Ngày dự kiến thông qua đề cương mới</Form.Label>
                            <Form.Control type="date" value={moment(selectedItem.detailInfo.ngayThongQua).format('YYYY-MM-DD')} disabled={true} className="shadow-none bg-white" />
                        </Form.Group>
                    </Col>
                </Row>
            )}
        </>
    );

    const renderChiTietCBHD = () => (
        <>
            <Row>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Lý do thay đổi</Form.Label>
                        <Form.Control as="textarea" rows={3} value={selectedItem?.detailInfo?.lyDoThayDoi || ''} disabled={true} className="bg-white shadow-none" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mb-3">
                    <FieldDisplayFile label="File ý kiến của CBHD" value={selectedItem?.detailInfo?.fileYKienCBHD} />
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mb-3">
                    <h6 className="font-weight-bold mb-3">Danh sách CBHD đề xuất</h6>
                    <div className="table-responsive">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>Họ và tên</th>
                                    <th>Đơn vị công tác</th>
                                    <th>Vai trò cán bộ</th>
                                    <th>File lý lịch</th>
                                    <th>File minh chứng</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(selectedItem?.chiTietThayDoiCBHDs || []).length > 0 ? (
                                    selectedItem.chiTietThayDoiCBHDs.map((cb, i) => (
                                        <tr key={i}>
                                            <td>{cb.hoTen}</td>
                                            <td>{cb.donViCongTac}</td>
                                            <td>
                                                {cb.loaiCanBoHuongDan === loaiCanBoHuongDanValue.huongDanChinh ? "Hướng dẫn chính" :
                                                 cb.loaiCanBoHuongDan === loaiCanBoHuongDanValue.huongDanPhu ? "Hướng dẫn phụ" :
                                                 cb.loaiCanBoHuongDan === loaiCanBoHuongDanValue.dongHuongDan ? "Đồng hướng dẫn" : "Không xác định"}
                                            </td>
                                            <td>
                                                <FieldDisplayFile value={cb.fileLyLichKhoaHoc} />
                                            </td>
                                            <td>
                                                <FieldDisplayFile value={cb.fileMinhChung} />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center">Không có cán bộ nào</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </>
    );
    
    const getSafeUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
        const safePath = path.startsWith('/') ? path : `/${path}`;
        return `${baseUrl}${safePath}`;
    };

    const renderChiTietGiaHan = () => (
        <>
            <Row>
                <Col md={12}>
                    <Form.Group>
                        <Form.Label className="font-weight-bold">Thời gian gia hạn (tháng) <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" value={selectedItem?.detailInfo?.thoiGianGiaHan || 0} disabled={true} className="bg-white shadow-none" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mb-3 mt-2">
                    <FieldDisplayFile label={<>File công văn của đơn vị công tác, đồng ý cho phép gia hạn <span className="text-danger">*</span></>} value={selectedItem?.detailInfo?.fileCongVan} />
                </Col>
                <Col md={12} className="mb-3 mt-2">
                    <FieldDisplayFile label={<>File báo cáo tiến độ thực hiện đề tài luận án (có xác nhận bộ môn, CBHD) <span className="text-danger">*</span></>} value={selectedItem?.detailInfo?.fileBaoCao} />
                </Col>
            </Row>
        </>
    );

    return (
        <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
            <Card.Body className="d-flex flex-column p-0">
            <div className="table-responsive flex-grow-1" ref={tableRef}>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: '50px' }}>STT</th>
                            <th>Mã NCS</th>
                            <th>Số CCCD</th>
                            <th>Họ và tên</th>
                            <th>Loại thay đổi</th>
                            <th>Đợt tuyển sinh</th>
                            <th>Thời hạn đào tạo</th>
                            <th className="text-center">Ngày nộp</th>
                            <th className="text-center">Trạng thái</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="9" className="text-center">Đang tải dữ liệu...</td>
                            </tr>
                        ) : items.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="text-center">Không có dữ liệu</td>
                            </tr>
                        ) : (
                            items.map((item, index) => {
                                const yeuCauInfo = item;
                                const ncsInfo = yeuCauInfo.hoSoNghienCuuSinhInfo || {};
                                const hsTS = ncsInfo.hoSoTuyenSinhInfo || {};

                                let thoiHanStr = '';
                                if (ncsInfo.thoiHanDaoTao === 0 || String(ncsInfo.thoiHanDaoTao) === '0' || (typeof ncsInfo.thoiHanDaoTao === 'string' && ncsInfo.thoiHanDaoTao.toLowerCase() === 'banam')) {
                                    thoiHanStr = '3 năm';
                                } else if (ncsInfo.thoiHanDaoTao === 1 || String(ncsInfo.thoiHanDaoTao) === '1' || (typeof ncsInfo.thoiHanDaoTao === 'string' && ncsInfo.thoiHanDaoTao.toLowerCase() === 'bonnam')) {
                                    thoiHanStr = '4 năm';
                                }

                                let cDate = item.ngayNop || item.detailInfo?.ngayNop || item.detailInfo?.NgayNop || item.createdDate;
                                const dateStr = cDate ? moment(cDate).format('DD/MM/YYYY HH:mm') : '';

                                return (
                                    <tr 
                                        key={item.id || item.Id || index}
                                        onClick={() => setSelectedRow(item)}
                                        className={selectedRow && (selectedRow.id || selectedRow.Id) === (item.id || item.Id) ? 'table-primary' : ''}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td className="text-center">{(page - 1) * pageSize + index + 1}</td>
                                        <td>{ncsInfo.maNCS || hsTS.soHoSo}</td>
                                        <td>{ncsInfo.soCCCD}</td>
                                        <td>{ncsInfo.hoTen}</td>
                                        <td>{getLoaiYeuCauText(yeuCauInfo.loaiYeuCau)}</td>
                                        <td>{ncsInfo.tenDotTuyenSinh}</td>
                                        <td>{thoiHanStr}</td>
                                        <td className="text-center">{dateStr}</td>
                                        <td className="text-center">
                                            {getTrangThaiLabel(item.trangThaiYeuCau)}
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </Table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3 p-2">
                <div>
                    <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                        {objectShowNumber.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.text}</option>
                        ))}
                    </Form.Control>
                </div>
                <div>
                    {totalRecords > 0 && (
                        <Pagination
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination pagination-sm no-margin"
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                        />
                    )}
                </div>
            </div>
            </Card.Body>
            {!isLoading && (
                <Card.Footer className="bg-white card-footer-sticky mt-2">
                    <div className="d-flex justify-content-end pr-2">
                        <BootstrapButton 
                            variant="info" 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, 'view')} 
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-eye mr-1"></i> Xem chi tiết
                        </BootstrapButton>
                        <BootstrapButton 
                            variant={selectedRow && (selectedRow.trangThaiYeuCau === 3 || selectedRow.trangThaiYeuCau === trangThaiYeuCauValue.hoanThanh) ? "success" : "outline-success"} 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, trangThaiYeuCauValue.hoanThanh)} 
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-check mr-1"></i> Duyệt
                        </BootstrapButton>
                        <BootstrapButton 
                            variant={selectedRow && (selectedRow.trangThaiYeuCau === 2 || selectedRow.trangThaiYeuCau === trangThaiYeuCauValue.boSung) ? "warning" : "outline-warning"} 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, trangThaiYeuCauValue.boSung)} 
                            className={selectedRow && (selectedRow.trangThaiYeuCau === 2 || selectedRow.trangThaiYeuCau === trangThaiYeuCauValue.boSung) ? "mr-2 text-white" : "mr-2"}
                            disabled={!selectedRow}
                        >
                            <i className="fa fa-edit mr-1"></i> Yêu cầu chỉnh sửa
                        </BootstrapButton>
                        <BootstrapButton 
                            variant={selectedRow && (selectedRow.trangThaiYeuCau === 4 || selectedRow.trangThaiYeuCau === trangThaiYeuCauValue.tuChoi) ? "danger" : "outline-danger"} 
                            size="sm" 
                            onClick={() => handleAction(selectedRow, trangThaiYeuCauValue.tuChoi)}
                            className="mr-2"
                            disabled={!selectedRow}
                        >
                            <i className="fas fa-times mr-1"></i> Từ chối
                        </BootstrapButton>
                        {selectedRow && selectedRow.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && (
                            <BootstrapButton variant="primary" size="sm" onClick={() => handleAction(selectedRow, 'danh-gia')}>
                                <i className="fas fa-clipboard-check mr-1"></i> Đánh giá đề tài
                            </BootstrapButton>
                        )}
                        {selectedRow && selectedRow.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && (
                            <BootstrapButton variant="primary" size="sm" onClick={() => handleAction(selectedRow, 'danh-gia')}>
                                <i className="fas fa-clipboard-check mr-1"></i> Đánh giá CBHD
                            </BootstrapButton>
                        )}
                        {selectedRow && selectedRow.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && (
                            <BootstrapButton variant="primary" size="sm" onClick={() => handleAction(selectedRow, 'danh-gia')}>
                                <i className="fas fa-clipboard-check mr-1"></i> Đánh giá gia hạn
                            </BootstrapButton>
                        )}
                    </div>

                </Card.Footer>
            )}

            {showModal && (
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            {modalMode === 'view' ? 'Chi tiết yêu cầu thay đổi' :
                             modalMode === 'danh-gia' ? 'Đánh giá yêu cầu thay đổi' :
                             modalMode === trangThaiYeuCauValue.hoanThanh ? 'Duyệt yêu cầu thay đổi' :
                             modalMode === trangThaiYeuCauValue.boSung ? 'Yêu cầu chỉnh sửa' : 'Từ chối yêu cầu'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                        {modalMode === 'view' ? (
                            <div className="bg-light p-3 m-3 rounded border">
                                <Form>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label className="d-block font-weight-bold">Trạng thái hiện tại</Form.Label>
                                                {getTrangThaiLabel(selectedItem?.trangThaiYeuCau)}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    
                                    {(() => {
                                        const history = [];
                                        if (selectedItem?.detailInfo?.ngayDuyet) {
                                            history.push({ label: 'Thời gian duyệt', time: selectedItem.detailInfo.ngayDuyet });
                                        }
                                        if (selectedItem?.detailInfo?.ngayTuChoi) {
                                            history.push({ label: 'Thời gian từ chối', time: selectedItem.detailInfo.ngayTuChoi });
                                        }
                                        if (selectedItem?.detailInfo?.ngayYeuCauChinhSua) {
                                            history.push({ label: 'Thời gian yêu cầu chỉnh sửa', time: selectedItem.detailInfo.ngayYeuCauChinhSua });
                                        }
                                        
                                        history.sort((a, b) => new Date(b.time) - new Date(a.time));
                                        
                                        return history.map((item, index) => (
                                            <Row key={index}>
                                                <Col md={12}>
                                                    <Form.Group>
                                                        <Form.Label className="d-block font-weight-bold">{item.label}</Form.Label>
                                                        <span>{moment(item.time).format('DD/MM/YYYY HH:mm')}</span>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        ));
                                    })()}
                                    
                                    {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && renderChiTietDeTai()}
                                    {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && renderChiTietCBHD()}
                                    {selectedItem?.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && renderChiTietGiaHan()}
                                    
                                    {selectedItem?.detailInfo?.ghiChuChinhSua && (
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold">Ghi chú chỉnh sửa</Form.Label>
                                                    <Form.Control 
                                                        as="textarea" 
                                                        rows={2} 
                                                        value={selectedItem.detailInfo.ghiChuChinhSua || selectedItem.detailInfo.GhiChuChinhSua} 
                                                        disabled={true} 
                                                        className="bg-white shadow-none"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}
                                </Form>
                            </div>
                        ) : modalMode === 'danh-gia' ? (
                            <div className="p-3">
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && (
                                    <DanhGiaDeTaiForm 
                                        thayDoiDeTaiId={selectedItem?.detailInfo?.id} 
                                        tenDeTaiDuKien={selectedItem?.detailInfo?.tenDeTaiDuKien}
                                        readOnly={false}
                                        refetchParent={refetch}
                                    />
                                )}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && (
                                    <DanhGiaCBHDForm 
                                        thayDoiCBHDId={selectedItem?.detailInfo?.id || selectedItem?.detailInfo?.Id} 
                                        chiTietThayDoiCBHDs={selectedItem?.chiTietThayDoiCBHDs}
                                        readOnly={false}
                                        refetchParent={refetch}
                                    />
                                )}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && (
                                    <DanhGiaGiaHanForm 
                                        giaHanDaoTaoId={selectedItem?.detailInfo?.id || selectedItem?.detailInfo?.Id} 
                                        detailInfo={selectedItem?.detailInfo}
                                        readOnly={false}
                                        refetchParent={refetch}
                                    />
                                )}
                            </div>
                        ) : (
                            <Form className="p-3">
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && renderChiTietDeTai()}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiCBHD && renderChiTietCBHD()}
                                {selectedItem?.loaiYeuCau === loaiYeuCauValue.giaHanDaoTao && renderChiTietGiaHan()}
                                
                                <hr />
                                {modalMode === trangThaiYeuCauValue.hoanThanh && selectedItem?.loaiYeuCau === loaiYeuCauValue.thayDoiDeTai && (
                                    <Form.Group>
                                        <Form.Label>Ngày thông qua đề tài</Form.Label>
                                        <Form.Control type="date" value={ngayThongQua} onChange={(e) => setNgayThongQua(e.target.value)} />
                                    </Form.Group>
                                )}
                                <Form.Group>
                                    <Form.Label>Ghi chú chỉnh sửa {modalMode !== trangThaiYeuCauValue.hoanThanh && <span className="text-danger">*</span>}</Form.Label>
                                    <Form.Control as="textarea" rows={3} value={ghiChu} onChange={(e) => setGhiChu(e.target.value)} />
                                </Form.Group>
                            </Form>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <BootstrapButton variant="secondary" onClick={() => setShowModal(false)}>Đóng</BootstrapButton>
                        {modalMode !== 'view' && modalMode !== 'danh-gia' && (
                            <BootstrapButton variant="primary" onClick={submitDuyet} disabled={(modalMode === trangThaiYeuCauValue.boSung || modalMode === trangThaiYeuCauValue.tuChoi) && !ghiChu.trim()}>
                                Lưu
                            </BootstrapButton>
                        )}
                    </Modal.Footer>
                </Modal>
            )}
        </Card>
    );
};

export default DuyetThayDoi;
